import { component } from 'picoapp';

export default component(async (node) => {
  let isShown = false;
  const trigger = node.querySelector('[data-trigger]');

  if (trigger === null) {
    return;
  }

  const texts = trigger.querySelectorAll('span');
  const medias = node.querySelectorAll('[data-item]');

  trigger.addEventListener('click', () => {
    medias.forEach((media, index) => {
      if (isShown) {
        media.hidden = index > 4;
      } else {
        media.hidden = false;
      }
    });

    texts.forEach((text) => {
      text.hidden = !text.hidden;
    });

    isShown = !isShown;
  });
});
